import route from "./route.component";
import routeUrls from "./route.urls";
import RouteTransforms from "./route.transforms";

const routeModule = angular
  .module("app.components.route", [])
  .component("routePage", route)
  .service("RouteTransforms", RouteTransforms)
  .config(routeUrls);

export default routeModule;



// WEBPACK FOOTER //
// ./src/pages/route/route.module.js